import z from "zod";

export const commandPaletteDataSchema = z.object({});

export type CommandPaletteDataProps = z.infer<typeof commandPaletteDataSchema>;
